import { computed, reactive } from 'vue'
import api from '@/api'

const quickSearchState = reactive({
  loading: false,
  term: '',
  language: '',
  searchType: '',
  searchResults: []
})

export default {
  quickSearchUse(language, searchType) {
    const state = quickSearchState
    state.language = language
    state.searchType = searchType
    let searchIterator = 0
    let asyncSearchIterator = searchIterator

    const resetQuickSearchResults = () => {
      state.searchResults = []
    }

    async function fetchData() {
      const response = await api.getAutoSuggestions(state.term, state.language, state.searchType)
      asyncSearchIterator += 1

      if (searchIterator === asyncSearchIterator) {
        state.searchResults = response.data.searchResults
      }
    }

    async function search() {
      if (!state.loading && state.term !== '') {
        state.loading = true
        fetchData().then(() => {
          state.loading = false
        })
      }
    }

    const setTerm = (term) => {
      state.term = term
      searchIterator += 1
      search()
    }

    return {
      loading: computed(() => state.loading),
      searchResults: computed(() => state.searchResults),
      term: computed(() => state.term),
      setTerm,
      resetQuickSearchResults,
      search
    }
  }
}
